/**
 * Share.tsx — the /share route. "Share a tool": pick one of your own Power Automate cloud flows and
 * document it, step by step, so a colleague can adopt it.
 *
 * THIS IS NOW A THIN ROUTE WRAPPER. All of the surface — the client-side data load, the
 * consent/feature/empty gating, the connector pre-detect, the flow picker and the upload overlay
 * itself — lives in `ShareOverlay`, so that the SAME surface can be opened in place over any page
 * (the Profile "Publish" button does exactly that) without a navigation and without a blocking route
 * loader. `/share` simply renders that overlay always-open; closing it steps back in history.
 *
 * WHY THE LOADER IS GONE: the old `shareLoader` ran three API calls before the route rendered, so
 * arriving on `/share` showed nothing until all three resolved. `ShareOverlay` loads the same data
 * itself, on open, behind a brief in-overlay spinner — the page frame appears immediately. The reads,
 * the error mapping (consent 409, no-approved-environment 503, 404 → feature disabled) and the trust
 * model are unchanged; they simply moved into `ShareOverlay.loadFlows` (see that file's header).
 */
import { useNavigate } from 'react-router';
import { ShareOverlay } from './ShareOverlay';

export function Share() {
  const navigate = useNavigate();
  // Always-open on its own route. Closing returns to wherever the user came from; if they deep-linked
  // straight to /share (no history to step back to), send them home.
  return (
    <ShareOverlay
      open
      onClose={() => {
        if (window.history.length > 1) navigate(-1);
        else navigate('/');
      }}
    />
  );
}
